import React from "react";
import { Button } from "@mui/material";
import toast from "react-hot-toast";

// Shown once, right after the codes are made: the server keeps only hashes.
export default function BackupCodes({ codes, onDone, doneLabel = "Continue" }) {
  const text = codes.join("\n");

  const copy = () => {
    if (!navigator.clipboard) {
      toast.error("Could not copy, please write them down");
      return;
    }
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success("Backup codes copied"))
      .catch(() => toast.error("Could not copy, please write them down"));
  };

  const download = () => {
    const blob = new Blob(
      [
        "CBX Suite backup codes\n",
        "Each code works once, if you can't use your authenticator app.\n\n",
        text,
        "\n",
      ],
      { type: "text/plain" }
    );
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "cbx-backup-codes.txt";
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <div>
      <p className="tf-text">
        Keep these backup codes somewhere safe. If you lose your phone, each
        code lets you sign in once. They will not be shown again.
      </p>
      <div className="tf-backup-grid">
        {codes.map((code) => (
          <code key={code}>{code}</code>
        ))}
      </div>
      <div className="tf-actions">
        <Button size="small" variant="outlined" onClick={copy}>
          Copy
        </Button>
        <Button size="small" variant="outlined" onClick={download}>
          Download
        </Button>
        {onDone && (
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={onDone}
            className="tf-primary"
          >
            {doneLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
